// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 345) return "345.4975dc8b4849491a8a0d.chunk.css";
	// return url for filenames based on template
	return "" + {"96":"vendors","524":"app"}[chunkId] + "." + {"96":"adf1332501bc5b994cb3","524":"6ab321b0e5a8eb1c7352"}[chunkId] + ".css";
};